module.exports = __webpack_public_path__ + "media/src/application/media/svg/icon-43-bbbea5142b3be7327a2d55988a8fda03.svg";